import React, { useState, useEffect } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

const SnackbarPopup = (props) => {

    const { isOpen, message } = props;
    const [open, setOpen] = useState(isOpen);

    let vertical = 'top';
    let horizontal = 'center';

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpen(false);
    };

    useEffect(() => {
        // console.log('snackbar mounted!');

        if (open) {
            setOpen(true);
        }

    }, []);

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                autoHideDuration={1500}
                onClose={handleClose}
                // message={message}
                key={vertical + horizontal}>
                <MuiAlert 
                    elevation={6} 
                    variant="filled" 
                    onClose={handleClose} 
                    severity="success">
                    {message}
                </MuiAlert>
            </Snackbar>
        </>
    );
}

export default SnackbarPopup;